import { render, staticRenderFns } from "./PageStadiumFields.vue?vue&type=template&id=43818301&"
import script from "./PageStadiumFields.vue?vue&type=script&lang=js&"
export * from "./PageStadiumFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports